import React, { useState } from 'react';
import {
    Filter,
    FilePlus2,
    Eye,
    Calendar,
    Building2
} from 'lucide-react';
import ExpandableSearchBar from '../components/ExpandableSearchBar';

import { useNavigate } from 'react-router-dom';

function Purchase() {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const mockBills = [
        {
            id: 1,
            billNo: '#BILL-2023-001',
            company: 'Modern Traders',
            gstin: '27AAAAA0000A1Z5',
            date: 'Oct 24, 2023',
            time: '10:30 AM',
            amount: '45,250.00'
        },
        {
            id: 2,
            billNo: '#BILL-2023-002',
            company: 'Aarogya Pharma',
            gstin: '09BBBBB1111B2Z6',
            date: 'Oct 25, 2023',
            time: '02:15 PM',
            amount: '1,12,800.00'
        },
        {
            id: 3,
            billNo: '#BILL-2023-003',
            company: 'Global Logistics',
            gstin: '33CCCCC2222C3Z7',
            date: 'Oct 26, 2023',
            time: '11:00 AM',
            amount: '8,400.00'
        },
        {
            id: 4,
            billNo: '#BILL-2023-003',
            company: 'Global Logistics',
            gstin: '33CCCCC2222C3Z7',
            date: 'Oct 26, 2023',
            time: '11:00 AM',
            amount: '8,400.00'
        },
        {
            id: 5,
            billNo: '#BILL-2023-004',
            company: 'Tech Innovations',
            gstin: '18DDDDD3333D4Z8',
            date: 'Oct 27, 2023',
            time: '03:45 PM',
            amount: '62,500.00'
        },
        {
            id: 6,
            billNo: '#BILL-2023-002',
            company: 'Aarogya Pharma',
            gstin: '09BBBBB1111B2Z6',
            date: 'Oct 25, 2023',
            time: '02:15 PM',
            amount: '1,12,800.00'
        },
        {
            id: 7,
            billNo: '#BILL-2023-003',
            company: 'Global Logistics',
            gstin: '33CCCCC2222C3Z7',
            date: 'Oct 26, 2023',
            time: '11:00 AM',
            amount: '8,400.00'
        },
        {
            id: 8,
            billNo: '#BILL-2023-003',
            company: 'Global Logistics',
            gstin: '33CCCCC2222C3Z7',
            date: 'Oct 26, 2023',
            time: '11:00 AM',
            amount: '8,400.00'
        },
        {
            id: 9,
            billNo: '#BILL-2023-001',
            company: 'Modern Traders',
            gstin: '27AAAAA0000A1Z5',
            date: 'Oct 24, 2023',
            time: '10:30 AM',
            amount: '45,250.00'
        },
        {
            id: 10,
            billNo: '#BILL-2023-004',
            company: 'Tech Innovations',
            gstin: '18DDDDD3333D4Z8',
            date: 'Oct 27, 2023',
            time: '03:45 PM',
            amount: '62,500.00'
        }
    ];

    const finalBills = [
        ...JSON.parse(localStorage.getItem('mock_purchase_orders') || '[]').map(order => ({
            id: order.id,
            billNo: order.invoiceNumber,
            company: order.companyName,
            gstin: order.gstin,
            date: order.dateTime.split(',')[0] || 'Today',
            time: order.dateTime.split(',')[1] || 'Now',
            amount: order.netAmount.toLocaleString()
        })),
        ...mockBills
    ];

    const filteredBills = finalBills.filter(bill =>
        (bill.company?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (bill.gstin?.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (bill.billNo?.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div className="min-h-screen bg-[#F4F9F8] p-8 font-sans">
            {/* Header Section */}
            <div className="flex items-center justify-between mb-8">
                <div className="flex items-center space-x-6">
                    <h1 className="text-[28px] font-bold text-[#1E4D43]">Purchase</h1>
                    <ExpandableSearchBar
                        searchTerm={searchTerm}
                        onSearchChange={setSearchTerm}
                        placeholder="Search by GSTIN number or company name"
                        fullWidth={false}
                        className="!rounded-full !py-0 !h-11 !max-w-md"
                    />
                </div>
                <div className="flex items-center space-x-4">
                    <button className="w-[45px] h-[45px] flex items-center justify-center bg-white rounded-full border border-gray-300 text-[#459B7A] hover:bg-gray-50 transition-all shadow-sm group">
                        <Filter size={22} className="text-[#459B7A] opacity-80 group-hover:opacity-100" />
                    </button>
                    {/* Removed Add Purchase Button */}
                </div>
            </div>

            {/* Bills Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
                {filteredBills.map((bill) => (
                    <div key={bill.id} className="bg-white rounded-[1.5rem] p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all relative group/card">
                        {/* Bill Badge & View Action */}
                        <div className="flex items-center justify-between mb-4">
                            <div className="inline-block px-3 py-1 bg-[#F2F4F7] rounded-lg">
                                <span className="text-[13px] font-bold text-[#526484] tracking-tight">{bill.billNo}</span>
                            </div>
                            <button
                                onClick={() => navigate(`/purchase/orders/${bill.id}`)}
                                className="w-9 h-9 flex items-center justify-center bg-[#007F7D] rounded-lg text-white transition-all shadow-md hover:bg-[#006664]"
                            >
                                <Eye size={18} strokeWidth={2.5} />
                            </button>
                        </div>

                        {/* Company Name */}
                        <h2 className="text-[22px] font-bold text-[#1E4D43] mb-2 truncate">{bill.company}</h2>

                        {/* GST Details */}
                        <div className="flex items-center space-x-2 text-[#526484] mb-6">
                            <Building2 size={16} />
                            <p className="text-[14px] font-bold tracking-tight uppercase">GST: {bill.gstin}</p>
                        </div>

                        <div className="border-t border-gray-50 pt-4 mt-auto">
                            {/* Date/Time Row */}
                            <div className="flex items-center space-x-2 text-[#526484] mb-4 font-semibold">
                                <Calendar size={16} />
                                <p className="text-[14px]">
                                    {bill.date} | {bill.time}
                                </p>
                            </div>

                            {/* Amount Section */}
                            <div className="space-y-1">
                                <p className="text-[10px] font-black text-[#A0AEC0] uppercase tracking-wider">Total Amount</p>
                                <p className="text-[26px] font-black text-[#10B981]">₹{bill.amount}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Purchase;
